import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { IMsalProvider } from "./IMsalProvider";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./MsalConfig";
import { appContext } from "../AppContext";

export class MsalProvider implements IMsalProvider
{
    public msalClient?: PublicClientApplication;

    public async initialise(clientId?: string, tenantDomain?: string): Promise<void>
    {
        const config = appContext().localStorageProvider.getAadConfig();
        clientId = clientId ?? config.clientId;
        tenantDomain = tenantDomain ?? config.tenantDomain;

        if (!clientId || !tenantDomain)
        {
            this.msalClient = undefined;
            return;
        }

        appContext().localStorageProvider.setAadConfig({ clientId: clientId, tenantDomain: tenantDomain });
        msalConfig.auth.clientId = clientId;
        msalConfig.auth.authority = `https://login.microsoftonline.com/${tenantDomain}/`;
        this.msalClient = new PublicClientApplication(msalConfig);
        await this.msalClient.initialize();
    }

    public login(email: string): Promise<AuthenticationResult>
    {
        if (!this.msalClient)
        {
            throw new Error('MSAL client not initialised.');
        }
        loginRequest.loginHint = email;
        return this.msalClient.loginPopup(loginRequest);
    }

    public getAccount(): (AccountInfo | undefined)
    {
        return this.msalClient?.getAllAccounts()[0];
    }

    public async getToken(): Promise<AuthenticationResult>
    {
        if (!this.msalClient)
        {
            throw new Error('MSAL client not initialised.');
        }
        const account = this.msalClient.getAllAccounts()[0];

        const authResult = await this.msalClient.acquireTokenSilent({
            account: account,
            scopes: [`api://${msalConfig.auth.clientId}/User.Read`],
        });
        return authResult;
    }
}
